<div class="loading">
    <mat-spinner class="spr" diameter="25"></mat-spinner>
</div>